import { objectSpread2 as _objectSpread2, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { DROPDOWN_VARIANT, DROPDOWN_SIZE, MENU_PLACEMENT, MENU_ALIGNMENT, LABEL_POSITION } from './Dropdown.constants.js';
import { getControlBgColor, getHeight, getBorderRadius, getControlHoverBgColor, getTypography, getMultiOptionBgColor, getOptionBgColor, getOptionPadding } from './Dropdown.utils.js';
import { getPaletteForVariant } from '../Button/ButtonBase.styles.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var customStyles = function customStyles(_ref) {
  var isGrouped = _ref.isGrouped,
    menuAlignment = _ref.menuAlignment,
    menuPlacement = _ref.menuPlacement,
    menuPosition = _ref.menuPosition,
    theme = _ref.theme,
    size = _ref.size,
    variant = _ref.variant;
  var colours = theme.colours,
    borderRadius = theme.borderRadius,
    typography = theme.typography,
    effects = theme.effects,
    sizing = theme.sizing;
  return {
    container: function container(styles) {
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        width: variant !== DROPDOWN_VARIANT.TERTIARY && 'fill-available'
      });
    },
    control: function control(styles, state) {
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: getControlBgColor(state, variant, colours),
        height: getHeight(size),
        minHeight: getHeight(size),
        padding: "0 ".concat(sizing.small),
        cursor: 'pointer',
        transition: '',
        borderRadius: getBorderRadius(state, size, borderRadius, menuPlacement, true),
        border: "".concat(sizing.xxtiny, " solid ").concat(state.menuIsOpen ? colours.canvas.primary.main : 'transparent'),
        borderBottom: state.menuIsOpen && size === DROPDOWN_SIZE.TINY && menuPlacement === MENU_PLACEMENT.BOTTOM && "".concat(sizing.xxtiny, " solid ").concat(colours.graphics.primary.main),
        borderTop: state.menuIsOpen && size === DROPDOWN_SIZE.TINY && menuPlacement === MENU_PLACEMENT.TOP && "".concat(sizing.xxtiny, " solid ").concat(colours.graphics.primary.main),
        boxShadow: state.menuIsOpen ? effects.dropShadow.regular : 'none',
        ':hover': {
          backgroundColor: getControlHoverBgColor(state, variant, colours),
          border: "".concat(sizing.xxtiny, " solid transparent"),
          boxShadow: effects.dropShadow.regular,
          cursor: state.isDisabled ? '' : 'pointer'
        }
      });
    },
    placeholder: function placeholder(styles) {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, styles), getTypography(size, typography)), {}, {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      });
    },
    valueContainer: function valueContainer(styles, state) {
      var marginLeft = 0;
      var paddingTop = 0;
      var alignItems = 'center';
      var maxHeight = '';
      if (state.isMulti) {
        marginLeft = size === DROPDOWN_SIZE.REGULAR ? "-".concat(theme.sizing.xxtiny) : "-".concat(theme.sizing.small);
        paddingTop = size === DROPDOWN_SIZE.REGULAR ? '0.4375rem' : '0.1875rem';
        alignItems = 'flex-start';
      }
      if (state.isMulti && !state.selectProps.isSearchable) {
        paddingTop = 0;
        maxHeight = '1.25rem';
      }
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        padding: "0 ".concat(sizing.tiny, " 0 0"),
        gap: "0.625rem ".concat(theme.sizing.xtiny),
        marginTop: "-".concat(theme.sizing.xtiny),
        overflow: 'hidden',
        flexWrap: 'wrap',
        alignItems: alignItems,
        paddingTop: paddingTop,
        maxHeight: maxHeight,
        marginLeft: marginLeft,
        '& button': {
          opacity: state.isDisabled && '0.28'
        },
        'input[aria-readonly="true"]': {
          position: 'absolute'
        }
      });
    },
    indicatorsContainer: function indicatorsContainer(styles, state) {
      var _getPaletteForVariant = getPaletteForVariant({
          theme: theme,
          $variant: state.selectProps.variant === 'secondary' ? 'secondary' : 'tertiary'
        }),
        strong = _getPaletteForVariant.strong;
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        height: getHeight(size),
        '&>button': {
          '&:hover': {
            backgroundColor: !state.selectProps.menuIsOpen && strong
          }
        }
      });
    },
    singleValue: function singleValue(styles) {
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        color: colours.ink.primary.main,
        margin: '0'
      }, getTypography(size, typography));
    },
    input: function input(styles, state) {
      var marginTop = 0;
      if (state.isMulti) {
        marginTop = size === DROPDOWN_SIZE.REGULAR ? "-".concat(theme.sizing.small, "}") : "-".concat(theme.sizing.xxtiny, "}");
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, styles), getTypography(size, typography)), {}, {
        color: colours.ink.primary.main,
        height: getHeight(size),
        margin: '0',
        padding: '0',
        marginTop: marginTop,
        '&>input::selection': {
          backgroundColor: theme.colours["interface"].main,
          color: theme.colours["interface"].ink
        }
      });
    },
    menu: function menu(styles, state) {
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        position: menuPosition,
        border: "".concat(sizing.xxtiny, " solid ").concat(colours.canvas.primary.main),
        borderRadius: getBorderRadius(state, size, borderRadius, menuPlacement),
        backgroundColor: colours.canvas.tertiary.main,
        boxShadow: effects.dropShadow.regular,
        width: variant !== DROPDOWN_VARIANT.TERTIARY && '100%',
        minWidth: variant === DROPDOWN_VARIANT.TERTIARY && '100%',
        padding: '0',
        margin: '0',
        top: menuPlacement === MENU_PLACEMENT.BOTTOM && '100%',
        bottom: menuPlacement === MENU_PLACEMENT.TOP && '100%',
        right: menuAlignment === MENU_ALIGNMENT.RIGHT && '0'
      });
    },
    menuList: function menuList(styles, state) {
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        borderRadius: getBorderRadius(state, size, borderRadius, menuPlacement),
        padding: '0'
      });
    },
    group: function group(styles) {
      return _objectSpread2(_objectSpread2({}, styles), {}, {
        padding: '0'
      });
    },
    groupHeading: function groupHeading(styles) {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, styles), typography.headingSmall), {}, {
        color: colours.ink.primary.main,
        backgroundColor: colours.canvas.primary.main,
        padding: "0.1875rem ".concat(theme.sizing.small, " "),
        textTransform: 'none',
        margin: '0'
      });
    },
    option: function option(styles, state) {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, styles), typography.bodyMedium), {}, {
        ':active': {
          color: colours.ink.primary.main
        },
        backgroundColor: state.isMulti ? getMultiOptionBgColor(state, colours) : getOptionBgColor(state, colours),
        cursor: 'pointer',
        color: colours.ink.primary.main,
        padding: getOptionPadding(sizing, size, isGrouped),
        height: size === DROPDOWN_SIZE.TINY && '1rem',
        ':hover': {
          backgroundColor: colours.canvas.secondary.strong,
          color: colours.ink.primary.main
        },
        overflow: variant !== DROPDOWN_VARIANT.TERTIARY && 'hidden',
        textOverflow: variant !== DROPDOWN_VARIANT.TERTIARY && 'ellipsis',
        whiteSpace: 'nowrap',
        '& label': {
          pointerEvents: 'none'
        }
      });
    },
    multiValue: function multiValue() {
      return {
        alignItems: 'center',
        backgroundColor: colours.canvas.tertiary.main,
        border: "".concat(theme.sizing.xtiny, " solid ").concat(colours["interface"].main),
        borderRadius: borderRadius.primary,
        color: colours.ink.primary.main,
        display: 'inline-flex',
        fontSize: theme.typography.bodyMedium.fontSize,
        fontWeight: theme.typography.bodyMedium.fontWeight,
        gap: sizing.tiny,
        height: '1.25rem',
        lineHeight: theme.typography.bodyMedium.LineHeight,
        padding: "0 0 0 ".concat(sizing.small)
      };
    },
    multiValueRemove: function multiValueRemove() {
      return {
        display: 'grid',
        placeItems: 'center',
        borderRadius: theme.borderRadius.primary,
        height: '1rem',
        width: '1rem',
        cursor: 'pointer',
        ':hover': {
          backgroundColor: theme.colours.canvas.secondary.strong
        },
        ':active': {
          backgroundColor: 'transparent'
        },
        ':focus-visible': {
          backgroundColor: theme.effects.focus,
          outline: 'none'
        },
        svg: {
          fill: theme.colours.graphics.primary.main
        }
      };
    }
  };
};
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  ", "\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
    $labelPosition = _ref2.$labelPosition;
  return $labelPosition === LABEL_POSITION.TOP ? "\n      flex-direction: column;\n      align-items: start;\n    " : "gap: ".concat(theme.sizing.tiny, ";");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colours.ink.primary.main;
});
var DropdownLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n  ", ";\n  white-space: nowrap;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colours.ink.primary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.headingMedium;
}, function (_ref6) {
  var $labelPosition = _ref6.$labelPosition,
    $size = _ref6.$size;
  return ($labelPosition === LABEL_POSITION.NONE || $size === DROPDOWN_SIZE.TINY) && 'display: none';
});
var IconContainer = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transition: transform 0.5s;\n  ", "\n  opacity: ", ";\n"])), function (_ref7) {
  var $rotate = _ref7.$rotate;
  return $rotate && 'transform: rotate(-180deg);';
}, function (_ref8) {
  var theme = _ref8.theme,
    $isDisabled = _ref8.$isDisabled;
  return $isDisabled ? theme.opacity.disabled : theme.opacity.secondary;
});
var SelectedCount = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  ", "\n  height: 1.25rem;\n  line-height: 1.25rem;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colours.canvas.secondary.main;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius.primary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return "0 ".concat(theme.sizing.small);
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.bodyMedium;
});
var SelectedItemsHiddenReference = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: -1;\n  display: flex;\n  gap: ", ";\n  visibility: hidden;\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.sizing.xtiny;
});
styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  gap: ", ";\n  justify-content: space-between;\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.sizing.small;
});
var customStyles$1 = customStyles;

export { Container, DropdownLabel, IconContainer, SelectedCount, SelectedItemsHiddenReference, customStyles$1 as default };
//# sourceMappingURL=Dropdown.styles.js.map
